module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid21_960x853.3e91d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid21_960x853.jpg
// module id = UBrx
// module chunks = 0